import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (params.get("paypal") === "1") { setStatus("paid"); return; }
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          if (!cleared.current) { clear(); cleared.current = true; }
          setStatus("paid");
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep trying */ }
      if (attempts.current >= 12) { setStatus("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, clear]);

  return (
    <div className="max-w-lg mx-auto px-4 py-28 text-center">
      {status === "checking" && (<><Loader2 className="w-14 h-14 mx-auto animate-spin text-[#0055FF]" /><h1 className="mt-6 font-heading text-2xl font-bold">Vérification du paiement...</h1></>)}
      {status === "paid" && (<><CheckCircle2 className="w-16 h-16 mx-auto text-[#E6007E]" /><h1 className="mt-6 font-heading text-3xl font-black">Paiement confirmé !</h1><p className="mt-3 text-gray-300">Merci pour votre commande. Un e-mail de confirmation vous a été envoyé et la production démarre.</p><Link to="/compte" className="mt-8 inline-flex btn-primary rounded-full px-7 py-3 font-bold">Voir mes commandes</Link></>)}
      {(status === "error" || status === "timeout") && (<><XCircle className="w-16 h-16 mx-auto text-red-400" /><h1 className="mt-6 font-heading text-2xl font-bold">Statut du paiement en attente</h1><p className="mt-3 text-gray-400">Si vous avez été débité, votre commande sera confirmée sous peu. Consultez votre espace client.</p><Link to="/compte" className="mt-8 inline-flex btn-blue rounded-full px-7 py-3 font-bold">Mon compte</Link></>)}
    </div>
  );
}
